import { COLORS } from '@btime/constants'
import React from 'react'

import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../..../../components/pdf/Preview'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Fm200 from './manutencao-preventiva-fm200/PdfDocument'
import Co2Lnp from './manutencao-preventiva-co2-lnp/PdfDocument'
import Co2Resinas from './manutencao-preventiva-co2-resinas/PdfDocument'
import ManutencaoPreventivaSdai from './manutencao-preventiva-sdai/PdfDocument'
import RelatorioManutencaoSdai from './relatorio-manutencao-sdai/PdfDocument'
import Center from '../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'

const PageContent = ({ templateId }) => {
  let content

  if (templateId === 1) {
    content = <Fm200 />
  } else if (templateId === 2) {
    content = <ManutencaoPreventivaSdai />
  } else if (templateId === 3) {
    content = <Co2Resinas />
  } else if (templateId === 4) {
    content = <Co2Lnp />
  } else if (templateId === 5) {
    content = <RelatorioManutencaoSdai />
  } else {
    content = (
      <Center>
        <IconBlock
          icon="RiFileWarningLine"
          title="Não foi possível gerar esse relatório"
          subtitle="Documento não suportado"
        ></IconBlock>
      </Center>
    )
  }

  return (
    <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.dark1 }}>
      <Grid align="stretch">
        <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 4.3rem)">
          <Preview>{content}</Preview>
        </Col>
      </Grid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
